module.exports = __webpack_public_path__ + "img/qr.d726d53b.svg";